




























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BusinessCard extends Vue {
  @Prop() public logo!: string; // logo
  @Prop() public logoTitle!: string; // 主标题
  @Prop() public mainText!: string; // 主要文案
  @Prop() public copyLink!: string; // 复制链接
  @Prop() public miniAppQrCode!: string; // 小程序码
  @Prop() public subText!: string; // 次要文案
  get hasLinkClass() {
    return this.copyLink ? 'hasLink' : '';
  }
}
